import { ReactNode, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormContext } from './FormContext';
import { useRegisterField } from './RegisterField';

export function useAttributeLabel(
  name: string,
  { label, hint }: { label?: ReactNode; hint?: string } = {}
) {
  useRegisterField(name, { label });

  const { resourceName } = useContext(FormContext);
  const { t } = useTranslation(resourceName);
  return useMemo(
    () => ({
      label: label ?? t(name),
      hint: hint ?? t(`${name}_hint`, { defaultValue: '' }),
      confirm: t(`${name}_confirm`, { defaultValue: '' })
    }),
    [hint, label, name, t]
  );
}
